<template>
  <!-- 图片上传 -->
  <div class="pictureUploadBox">
    <!-- 公共头部 -->
    <job-header-simple header_title="身份认证"></job-header-simple>
    <!-- 新增内容部分 -->

    <div class="pictureUploadContent" v-if="step == '0'">
      <!-- <van-cell 
            v-if="showCardInfo"
            @click="showCardImg"
            class="pictureUploadVanCell" 
            title-class="pictureUploadTitle"  
            title="身份证图片" 
            is-link 
            :arrow-direction="isShowImg?'up':'down'" 
            value="" /> -->
      <div class="CardImgContent">
        <van-uploader
          :before-delete="beforeDeleteFront"
          v-model="frontPicArr"
          :max-count="1"
          :before-read="beforeRead"
          class="upImg"
        >
          <img class="upBg" :src="frontBgImg" />
        </van-uploader>
        <van-uploader
          :before-delete="beforeDeleteBack"
          v-model="backPicArr"
          :max-count="1"
          :before-read="beforeRead"
          class="upImg"
        >
          <img class="upBg" :src="backBgImg" />
        </van-uploader>
        <van-divider>照片上传要求</van-divider>
        <div class="img">
          <img src="@/assets/error_example.png" alt />
        </div>
      </div>
    </div>
    <div v-if="step == '1'" class="userCardInfo pictureUploadContent">
      <header class="header-title">身份信息</header>
      <van-field
        label="姓名"
        label-align="right"
        label-width="1.6rem"
        v-model="cardInfo.name"
        readonly
      />
      <van-field
        label="证件号"
        label-align="right"
        v-model="cardInfo.idNumber"
        label-width="1.6rem"
        readonly
      />
      <van-field
        label-align="right"
        v-model="cardInfo.sexName"
        readonly
        name="picker"
        label-width="1.6rem"
        label="性别"
        placeholder="请选择性别"
      />
    </div>
    <div v-if="step == '1'" class="userCardInfo pictureUploadContent">
      <header class="header-title">
        <van-cell
          title="收款名称"
          :value="collectionMethodLabel[collectionMethod]"
          @click="handlePicker('collectionMethod')"
          :is-link="collectionMethodTypes.length > 1"
        />
      </header>
      <template v-if="collectionMethod === 1">
        <van-field
          type="digit"
          maxlength="23"
          label-align="right"
          @input="
            cardInfo.bankCard = cardInfo.bankCard
              .replace(/[^\d]/g, '')
              .replace(/....(?=.)/g, '$& ')
          "
          @blur="changeAccount"
          label="银行卡号"
          label-width="1.6rem"
          v-model="cardInfo.bankCard"
          placeholder="请输入储蓄银行卡卡号"
        />
        <van-field
          label-width="1.6rem"
          label-align="right"
          readonly
          label="银行名称"
          :value="cardInfo.bankName"
        />
        <van-field
          label="所属城市"
          label-width="1.6rem"
          label-align="right"
          v-model="cardInfo.cityName"
          is-link
          readonly
          @click="isCityClicked = true"
          placeholder="请选择所属城市"
        />
      </template>
      <template v-if="collectionMethod === 2">
        <van-field
          label="收款账号"
          label-align="right"
          label-width="1.6rem"
          v-model="cardInfo.receiptAccount"
          :placeholder="'请输入' + cardInfo.name + '的支付宝账号'"
        />
      </template>
      <template v-if="collectionMethod === 3">
        <van-field
          v-if="collectionMethod === 3"
          label="收款账号"
          label-align="right"
          label-width="1.6rem"
        >
          <template v-slot:button>
            <van-button
              v-if="collectionMethod === 3"
              type="info"
              color="#07C160"
              class="weChatPay"
              block
              size="small"
              @click="toAddWeChatPay"
              >授权添加
            </van-button>
          </template>
        </van-field>
      </template>
    </div>
    <div v-if="step == '1'" class="userCardInfo pictureUploadContent">
      <header class="header-title">
        <van-cell
          title="身份验证"
          :value="authenticationMethodLabel[authenticationMethod]"
          @click="handlePicker('authenticationMethod')"
          :is-link="filterColumns.length > 1"
        />
      </header>
    </div>
    <div class="base-info">
      <p v-if="step == '1'" class="note">
        温馨提示：请核对并确认身份证和收款信息，信息有误将无法完成认证。
      </p>
      <van-button
        v-if="step == '1'"
        type="info"
        size="large"
        class="goBackBtn"
        @click="bankUpload"
        color="#e3af22"
        >{{ btnText1 }}
      </van-button>
      <van-button
        type="info"
        size="large"
        @click="handleIndentify"
        color="#233BB7"
        >{{ btnText }}
      </van-button>
    </div>
    <van-popup v-model="isCityClicked" position="bottom">
      <van-picker
        title="城市选择"
        show-toolbar
        :columns="cityList"
        @confirm="handleCityConfirm"
        @cancel="isCityClicked = false"
      />
    </van-popup>
    <van-popup v-model="showcollectionMethod" position="bottom">
      <van-picker
        show-toolbar
        :columns="collectionMethodTypes"
        :default-index="selectedIndex"
        @confirm="chooseCollectionMethod"
        @cancel="showcollectionMethod = false"
      />
    </van-popup>
    <van-popup v-model="showauthenticationMethod" position="bottom">
      <van-picker
        show-toolbar
        :columns="filterColumns"
        :default-index="selectedIndex"
        @confirm="chooseAuthentication"
        @cancel="showauthenticationMethod = false"
      />
    </van-popup>
    <van-dialog
      v-model="showPersonnel"
      title="温馨提示"
      :showCancelButton="true"
      @cancel="cancelPersonnel"
      @confirm="confirmPersonnel"
      confirmButtonText="修改信息"
      cancelButtonText="重新登录"
      class="codeDialog"
    >
      <div class="content">
        <div class="top-content">
          该灵工已绑定另外手机号，请使用已认证号码（{{
            filterPhone(this.bandMobile)
          }}）登录，【重新登录】【修改信息】
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showWeChatPay"
      title="温馨提示"
      :showCancelButton="true"
      @confirm="confirmAuthorize"
      confirmButtonText="确认并授权"
      class="codeDialog"
    >
      <div class="content">
        <div class="top-content">
          <p>{{ $store.getters.platformName }} 申请获取您的openid信息</p>
          <p class="grey-label">
            实现微信支付至您的零钱账户及保障交易安全所必须的功能
          </p>
        </div>
        <div class="bow-content">
          <p>
            当前收款账号为{{ $store.getters.userInfo.name }}<br />
            请确认是否与微信实名制姓名一致？
          </p>
          <p class="grey-label">
            如不一致，请登录对应微信账号，<br />
            否则无法发放
          </p>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { getWechatAutoLoginCode } from '@/utils/auth'
import {
  //   saveEmployeeAccountMessage,
  //   employeeSaveToUserToCode,
  easyRegisterIndividualFace,
  simVerifyUser,
  getMessageFromIdCard,
  saveToUserToCode,
  getCerficationTypesByTaskId,
  checkUniqueIdNumber,
} from '@/api/employee/request'
import jobHeaderSimple from '@/components/header/header.vue'
import captha from '@/components/captha.vue'
import { getAllCity } from '@/api/contract/taskRequest'
import api from '@/api/list'
import { setToken } from '@/utils/auth'
import { browserUA } from '@/utils/browserUA'
import jwt_decode from 'jwt-decode'
import {
  Button,
  Field,
  Toast,
  Uploader,
  Dialog,
  Divider,
  Popup,
  Picker,
  Cell,
} from 'vant'

export default {
  name: 'cannelIndex',
  components: {
    jobHeaderSimple,
    captha,
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [Uploader.name]: Uploader,
    [Dialog.name]: Dialog,
    [Divider.name]: Divider,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      showPersonnel: false,
      isCityClicked: false, //是否展示选择银行卡城市
      cityList: [], //银行卡城市列表
      routerPath: '', //调转地址
      token: '', //携带的token
      step: '0', // 0 第一步 1第二步
      btnText1: '返回上一步，重新上传', //返回按钮
      btnText: '下一步', //确认按钮
      frontPicArr: [], //身份证正面照片
      backPicArr: [], //身份证反面照片
      username: this.$route.query.username,
      frontBgImg: require('@/assets/bg_front.png'), //身份证正面默认照片
      backBgImg: require('@/assets/bg_back.png'), //身份证反面默认照片
      loadingFlag: false,
      showauthenticationMethod: false,
      showcollectionMethod: false,
      selectedIndex: 1, //认证类型选择
      isUploadCard: false, //是否上传过身份证正反面
      isHaveCardImg: false, //是否已在数据库存在身份证图片资源
      showWeChatPay: false, //微信授权
      cardInfo: {
        //身份证识别信息
        sexName: '',
        gender: '',
        idNumber: '',
        name: '',
        bankCard: '', //银行卡号
        cityName: '', //银行卡所属城市
        cityId: '',
        bankName: '', //银行卡名称
        receiptAccount: '', //支付宝账号
      },
      columns: [
        { text: '男', value: '0' },
        { text: '女', value: '1' },
      ],
      collectionMethodLabel: {
        3: '微信收款',
        2: '支付宝收款',
        1: '银行卡',
      },
      authenticationMethodLabel: {
        telecom3: '手机号认证',
        card: '银行卡三要素',
        bankcard4: '银行卡四要素',
        face: '人脸识别',
      },
      collectionMethod: 1, //收款方式
      authenticationMethod: 'card', //认证方式 默认银行卡三要素
      hasAlipay: false, //是否支持支付宝支付
      hasWeChatPay: false, //是否支付微信支付
      collectionMethodTypes: [
        //{ text: '银行卡(储蓄卡)', value: 'hasBank' },
        //{ text: '支付宝', value: 'hasAlipay' },
        // { text: '微信（零钱账户）', value: 'hasWeChatPay' },
      ],
      authenticationMethodTypes: [
        //{ text: '银行卡三要素', value: 'card' },
        //{ text: '银行卡四要素', value: 'bankcard4' },
        //{ text: '刷脸认证', value: 'face' },
        //{ text: '运营商三要素', value: 'telecom3' },
      ],
      wechatCode: '',
      bandMobile: '',
    }
  },
  computed: {
    filterColumns() {
      if (this.collectionMethod != 1) {
        return this.authenticationMethodTypes.filter(
          (item) => item.value === 'telecom3' || item.value === 'face'
        )
      } else {
        return this.authenticationMethodTypes
      }
    },
  },
  created() {
    this.init()
    getAllCity().then((res) => {
      this.cityList = res.data.data
    })
    this.initData()
    this.changeauthenticationMethod()
    this.initActiveUserInfo()
  },
  mounted() {},
  methods: {
    queryStatus(data) {
      return new Promise((resolve, reject) => {
        checkUniqueIdNumber(data)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    filterPhone(data) {
      if (data) {
        return data.substr(0, 3) + '****' + data.substr(7)
      }
    },
    init() {
      //微信授权跳转
      const urlParams = new URLSearchParams(window.location.search)
      let code = urlParams.get('code')
      if (code) {
        //获取了code
        this.wechatCode = code
        this.step = '1'
        this.collectionMethod = 3
        this.authenticationMethod = this.$route.query.authenticationMethod
      }
    },
    //重新登录
    cancelPersonnel() {
      this.showPersonnel = false
      let param = {
        path: '/simpleRegister',
        query: {
          taskId: decodeURIComponent(this.$route.query.taskId),
        },
      }
      this.$router.push(param)
    },
    //修改信息
    confirmPersonnel() {
      this.showPersonnel = false
      this.bankUpload()
    },
    //同意授权
    confirmAuthorize() {
      //是否已经有code
      if (typeof getWechatAutoLoginCode() != 'undefined') {
        this.wechatCode = getWechatAutoLoginCode()
      } else {
        const hashContent = window.location.hash.substring(1)
        let encodeUrl = encodeURIComponent(
          process.env.VUE_APP_BASE_API +
            '/#' +
            hashContent +
            '&formType=empowerCode&authenticationMethod=' +
            this.authenticationMethod
        )

        window.location.replace(
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
            process.env.VUE_APP_WXAPPID +
            '&redirect_uri=' +
            encodeUrl +
            '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
        )
      }
    },
    toAddWeChatPay() {
      //判断是是不是微信公众号环境
      browserUA().then((browserType) => {
        if (browserType == 'WX') {
          //弹出用户授权信息
          this.showWeChatPay = true
        } else {
          Dialog.alert({
            title: '温馨提示',
            message:
              ' 请关注并前往“' +
              this.$store.getters.platformName +
              '”微信公众号中操作',
            confirmButtonText: '知道了',
            theme: 'round-button',
          }).then(() => {
            // on close
          })
        }
      })
    },
    handlePicker(type) {
      if (type === 'authenticationMethod') {
        if (this.filterColumns.length > 1) {
          this['show' + type] = true
          this.selectedIndex = this.filterColumns.findIndex(
            (item) => item.value === this.authenticationMethod
          )
        }
      } else {
        if (this[type + 'Types'].length > 1) {
          this['show' + type] = true
          this.selectedIndex = this[type + 'Types'].findIndex(
            (item) => item.value === this.collectionMethod
          )
        }
      }
    },
    initActiveUserInfo() {
      getCerficationTypesByTaskId({
        taskId: decodeURIComponent(this.$route.query.taskId),
      }).then((res) => {
        if (res.data.status == '200') {
          if (
            res.data.data.cerficationTypes &&
            res.data.data.cerficationTypes.length > 0
          ) {
            let arr = res.data.data.cerficationTypes.split(',')
            arr.map((item) => {
              let obj = {
                text: this.authenticationMethodLabel[item],
                value: item,
              }
              this.authenticationMethodTypes.push(obj)
            })
          }
          if (
            res.data.data.receivePayType &&
            res.data.data.receivePayType.length > 0
          ) {
            let arr2 = JSON.parse(res.data.data.receivePayType)
            arr2.map((item) => {
              let obj1 = {
                text: this.collectionMethodLabel[item.payMethod],
                value: item.payMethod,
              }
              this.collectionMethodTypes.push(obj1)
            })
          }
        }
      })
      console.log(this.authenticationMethodTypes)
    },

    initData() {
      if (this.$route.query.front && this.$route.query.back) {
        let front = process.env.VUE_APP_FILE_PATH + this.$route.query.front
        this.getBase64(front, (dataURL) => {
          this.frontBgImg = dataURL
        })
        let back = process.env.VUE_APP_FILE_PATH + this.$route.query.back
        this.getBase64(back, (dataURL) => {
          this.backBgImg = dataURL
        })
        this.isHaveCardImg = true
      }
    },
    // url 转base64
    getBase64(url, callback) {
      var Img = new Image(),
        dataURL = ''
      Img.src = url + '?v=' + Math.random()
      Img.setAttribute('crossOrigin', 'Anonymous')
      Img.onload = function() {
        var canvas = document.createElement('canvas'),
          width = Img.width,
          height = Img.height
        canvas.width = width
        canvas.height = height
        canvas.getContext('2d').drawImage(Img, 0, 0, width, height)
        dataURL = canvas.toDataURL('image/jpeg')
        return callback ? callback(dataURL) : null
      }
    },
    changeAccount() {
      let currentBankCard = this.cardInfo.bankCard.replace(/\s/g, '')
      if (!currentBankCard || typeof currentBankCard == 'undefined') {
        Toast.fail('请填写银行卡号!')
        return false
      }
      if (currentBankCard.length < 16 || currentBankCard.length > 19) {
        Toast.fail('银行卡号位数限定16~19位!')
        return false
      }
      const toastLoading = Toast.loading({
        message: '正在获取银行卡号...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      saveToUserToCode({
        code: currentBankCard,
      }).then((res) => {
        toastLoading.clear() //关闭加载效果
        if (res.data.status == '200') {
          if (
            res.data.data.type == '' ||
            res.data.data.type == null ||
            res.data.data.type == undefined
          ) {
            Toast.fail('未知银行，请更换银行卡或联系客服')
          } else if (
            res.data.data.type == '储蓄卡' ||
            res.data.data.type == '借记卡'
          ) {
            if (res.data.data.code == 1) {
              Toast.fail(res.data.data.name + '存在风险交易，请更换银行卡')
            } else if (res.data.data.code == 2) {
              Toast.fail('暂不支持' + res.data.data.name + '，请更换银行卡')
            } else if (res.data.data.code == 3) {
              Toast.fail(
                res.data.data.name +
                  '银行' +
                  res.data.data.bin +
                  '不支持，请更换银行卡'
              )
            } else {
              this.cardInfo.bankName = res.data.data.name
            }
          } else {
            Toast.fail('仅支持储蓄卡，请输入正确的储蓄卡号!!')
          }
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    //点击确认城市
    handleCityConfirm(value, value2) {
      this.cardInfo.cityId = this.cityList[value2[0]].children[value2[1]].id
      this.cardInfo.cityName = value.join('/')
      this.isCityClicked = false
    },
    //点击展开图片详情
    // showCardImg(){
    //     this.isShowImg = !this.isShowImg;
    // },
    //修改收款名称
    chooseCollectionMethod(value, index) {
      this.collectionMethod = value.value
      this.selectedIndex = index
      this.changeauthenticationMethod()
      this.showcollectionMethod = false
    },
    //选择认证方式
    chooseAuthentication(value, index) {
      this.authenticationMethod = value.value
      this.selectedIndex = index
      this.showauthenticationMethod = false
    },
    //改变收款账号，应该修改相应的认证方式
    changeauthenticationMethod() {
      if (this.collectionMethod != 1) {
        // 优先选择 telecom3，如果没有 telecom3 则选择其他可用选项中的第一个
        const telecom3Available = this.filterColumns.some(
          (item) => item.value === 'telecom3'
        )

        if (telecom3Available) {
          this.authenticationMethod = 'telecom3'
        } else if (this.filterColumns.length > 0) {
          // 如果没有 telecom3，则选择第一个可用的选项
          this.authenticationMethod = this.filterColumns[0].value
        }
      } else {
        const cardItem = this.authenticationMethodTypes.find(
          (item) => item.value === 'card'
        )
        const bankcard4Item = this.authenticationMethodTypes.find(
          (item) => item.value === 'bankcard4'
        )

        if (cardItem) {
          this.authenticationMethod = 'card'
        } else if (bankcard4Item) {
          this.authenticationMethod = 'bankcard4'
        } else if (this.authenticationMethodTypes.length > 0) {
          // 如果前两者都不存在，则选择第一个可用的选项
          this.authenticationMethod = this.authenticationMethodTypes[0].value
        }
      }
    },
    //返回上一步，重新上传
    bankUpload() {
      this.step = '0' //回到第一步
      this.btnText = '下一步'
    },
    //提交身份证去ocr认证
    ocr(param) {
      Toast.loading({
        mask: true,
        message: '识别中...',
        duration: 0,
      })
      getMessageFromIdCard(param)
        .then((res) => {
          Toast.clear()
          if (res.data.status == '200') {
            // 校验通过，调用身份证认证接口
            this.step = '1'
            this.isUploadCard = true //身份证已认证通过
            this.btnText = '信息无误，直接提交'
            this.routerPath = res.data.data.routerPath
            let result = res.data.data
            this.cardInfo.name = result.name
            this.cardInfo.gender = result.gender
            this.cardInfo.idNumber = result.idNumber
            this.cardInfo.employeeAccount = result.employeeAccount
            if (result.gender.toString() === '0') {
              this.cardInfo.sexName = '女'
            } else {
              this.cardInfo.sexName = '男'
            }
            if(result.bankName&&result.bankName!=='支付宝'&&result.bankName!=='微信'){
                this.cardInfo.bankName = result.bankName;
                if(result.bankAccount){
                    this.cardInfo.bankCard = result.bankAccount;
                }
                if(result.provinceName&&result.cityName){
                    this.cardInfo.cityName = result.provinceName+"/"+result.cityName
                }
                
            }

          } else {
            //校验失败
            Toast.fail(res.data.message)
          }
        })
        .catch((err) => {
          Toast.clear(err)
        })
    },
    //人脸识别
    handleFaceIndentify(data) {
      // 保存当前路由信息到 sessionStorage
      const currentPictureRouteInfo = {
        path: this.$route.path,
        query: this.$route.query,
      }
      localStorage.setItem(
        'previousPictureRoute',
        JSON.stringify(currentPictureRouteInfo)
      )
      easyRegisterIndividualFace(data).then((res) => {
        if (res.status == '200') {
          // debugger
          let json = JSON.parse(res.data.data)
          if (json == null) {
            Toast.fail(res.data.message)
          } else {
            browserUA().then((browserType) => {
              if (browserType == 'androidAPP') {
                window.VpShopJs.bodyCheck(JSON.stringify({ url: json.url }))
              } else {
                location.href = json.url
              }
            })
          }
        } else {
          Toast.fail('发起认证失败')
        }
      })
    },
    //去三要素认证
    simVerifyUserData(param) {
      Toast.loading({
        mask: true,
        message: '认证中...',
        duration: 0,
      })
      simVerifyUser(param)
        .then((res) => {
          Toast.clear()
          let result = res.data
          if (result.status == '200') {
            // 校验通过，调用身份证认证接口
            let parm = {
              path: result.data.routerPath,
              query: {},
            }
            this.token = result.data.token
            setToken(result.data.token)
            this.$store.commit('SET_TOKEN', result.data.token)
            this.$store.commit('SET_JWTDECODE', jwt_decode(result.data.token))
            this.$store.dispatch('getUserInfo')

            if (
              result.data.id &&
              result.data.id != null &&
              result.data.id != undefined &&
              result.data.id != ''
            ) {
              parm.query.id = result.data.id
            }
            if (
              result.data.obj &&
              result.data.obj != null &&
              result.data.obj != undefined &&
              result.data.obj != ''
            ) {
              parm.query.obj = result.data.obj
            }
            this.$router.push(parm)
          } else {
            //校验失败
            Toast.fail(res.data.message)
          }
        })
        .catch((err) => {
          Toast.clear(err)
        })
    },
    //去认证
    async handleIndentify() {
      //需要先查询是否已添加人员

      if (this.step === '0' && !this.isUploadCard) {
        //并且身份证是没有认证的身份证
        if (this.frontPicArr.length == 0 || this.backPicArr.length == 0) {
          if (this.isHaveCardImg) {
            //后端传过来了身份证正反面
            let param = {
              taskId: decodeURIComponent(this.$route.query.taskId),
              username: this.username,
              back: this.backBgImg,
              front: this.frontBgImg,
            }
            this.ocr(param)
          } else {
            Dialog.alert({
              title: '提示',
              message: '请确认是否上传完整的证件正反面!',
            }).then(() => {})
          }
        } else {
          let param = {
            taskId: decodeURIComponent(this.$route.query.taskId),
            username: this.username,
            back: this.backPicArr[0].content,
            front: this.frontPicArr[0].content,
          }
          this.ocr(param)
        }
      } else if (this.step === '0' && this.isUploadCard) {
        //返回了上一步 但是身份证图片没有更换
        this.step = '1'
        this.btnText = '信息无误，直接提交'
      } else {
        let flag = true
        let str = ''
        if (this.collectionMethod === 1) {
          if (this.cardInfo.bankName === '') {
            str = '请确认是否填写正确的银行卡!'
            flag = false
          } else if (this.cardInfo.cityName === '') {
            str = '请确认是否选择银行卡城市!'
            flag = false
          }
        }
        if (this.collectionMethod === 2) {
          if (this.cardInfo.receiptAccount === '') {
            str = '请确认是否填写收款账号!'
            flag = false
          }
        }
        if (!flag) {
          Dialog.alert({
            title: '提示',
            message: str,
          }).then(() => {})
          return false
        }

        //需要先查询是不是有重复的
        const statusResult = await this.queryStatus({
          idNumber: this.cardInfo.idNumber,
          mobile: this.username,
        })
        if (statusResult && statusResult.data && statusResult.data.data) {
          let res = statusResult.data.data
          if (!res.isUnique) {
            this.bandMobile = res.mobile
            this.showPersonnel = true
          }
        }
        if (this.showPersonnel) {
          return false
        }
        //确认信息 提交确认
        if (this.authenticationMethod == 'face') {
         let addr1 = this.cardInfo.cityName.split('/')
          //人脸认证
          let param2 = {
            username: this.username,
            taskId: decodeURIComponent(this.$route.query.taskId),
            employeeAccount: this.cardInfo.employeeAccount,
            identityType: this.authenticationMethod,
            receiptType: this.collectionMethod,
            receiptAccount: this.cardInfo.receiptAccount,
            bankAccount: this.cardInfo.bankCard.replace(/\s/g, ''),
            provinceName: addr1[0],
            cityName: addr1[1],
            bankName: this.cardInfo.bankName,
          }
          this.handleFaceIndentify(param2)
          return false
        }

        let content = `<ul class='baseInfo'>
                                 <li><span class='labelText'>姓名<span></span></span><span class='colon'>:</span>${this.cardInfo.name}</li>
                                 <li><span class='labelText'>证件号<span></span></span><span class='colon'>:</span>${this.cardInfo.idNumber}</li>
                                 <li><span class='labelText'>性别<span></span></span><span class='colon'>:</span>${this.cardInfo.sexName}</li>`

        if (
          this.authenticationMethod === 'bankcard4' ||
          this.authenticationMethod === 'card'
        ) {
          content += `<li><span class='labelText'>银行卡号<span></span></span><span class='colon'>:</span>${this.cardInfo.bankCard}</li>
                        <li><span class='labelText'>银行名称<span></span></span><span class='colon'>:</span>${this.cardInfo.bankName}</li>`
        }

        if (
          this.authenticationMethod === 'bankcard4' ||
          this.authenticationMethod === 'telecom3'
        ) {
          content += `<li><span class='labelText'>手机号<span></span></span><span class='colon'>:</span>${this.username}</li>`
        }
        content += `</ul>`
        Dialog.confirm({
          title: '信息确认',
          message: content,
          confirmButtonText: '确认无误',
          cancelButtonText: '取消',
          className: 'infoMark',
        })
          .then(() => {
            let addr1 = this.cardInfo.cityName.split('/')
            let param1 = {
              username: this.username,
              taskId: decodeURIComponent(this.$route.query.taskId),
              bankAccount: this.cardInfo.bankCard.replace(/\s/g, ''),
              provinceName: addr1[0],
              cityName: addr1[1],
              bankName: this.cardInfo.bankName,
              employeeAccount: this.cardInfo.employeeAccount,
              identityType: this.authenticationMethod,
              receiptType: this.collectionMethod,
              receiptAccount: this.cardInfo.receiptAccount,
            }
            this.simVerifyUserData(param1)
          })
          .catch(() => {})

        //已经认证成功，创建了账号 银行三要素认证
        // if(this.cardInfo.bankCard.length==0){
        //       Dialog.alert({
        //         title: "提示",
        //         message: "请填写银行卡号!",
        //         })
        //         return false
        // }
        // Toast.loading({
        // mask: true,
        // message: "认证中...",
        // duration: 0,
        // });
        // let addr = this.cardInfo.cityName.split("/");
        // api.simpleIdImage(
        //     {
        //     front: this.frontPicArr[0].content,
        //     back: this.backPicArr[0].content,
        //     bankCard: this.cardInfo.bankCard,
        //     provinceName: addr[0],
        //     cityName: addr[1],
        //     },
        //     { method: "post" }
        // )
        // .then((res) => {
        //     if (res.status == "200") {
        //         Toast.clear();
        //     if (res.data.status != "200") {
        //         Toast.fail("认证失败," + res.data.message);
        //         return;
        //     } else if (res.data.status == "200") {
        //         Toast.loading({
        //         duration: 3000, // 持续展示 toast
        //         forbidClick: true, // 禁用背景点击
        //         loadingType: "spinner",
        //         message: "认证成功，即将跳转！",
        //         });
        //         this.$router.push({
        //         path: "/contractBase",
        //         query: { obj: this.$route.query.contractId, val: this.val },
        //         });

        //     }
        //     } else {
        //     //验证失败，请检查上传照片是否完成
        //     this.$toast({
        //         message: res.message,
        //     });
        //     }
        // });
      }
    },
    initCardInfo() {
      this.cardInfo.name = ''
      this.cardInfo.gender = ''
      this.cardInfo.idNumber = ''
      this.cardInfo.employeeAccount = ''
      this.cardInfo.sexName = ''
    },
    beforeDeleteBack(file, detail) {
      return new Promise((resolve, reject) => {
        this.$dialog
          .confirm({
            message: '确定删除图片？',
          })
          .then(() => {
            this.backPicArr.splice(detail.index, 1)
            this.$toast.success('删除成功')
            if (this.isUploadCard) {
              this.isUploadCard = false
              this.initCardInfo()
            }

            resolve()
          })
          .catch((error) => {
            this.$toast.success('已取消')
            reject(error)
          })
      })
    },
    beforeDeleteFront(file, detail) {
      return new Promise((resolve, reject) => {
        this.$dialog
          .confirm({
            message: '确定删除图片？',
          })
          .then(() => {
            this.frontPicArr.splice(detail.index, 1)
            this.$toast.success('删除成功')
            if (this.isUploadCard) {
              this.isUploadCard = false
              this.initCardInfo()
            }
            resolve()
          })
          .catch((error) => {
            this.$toast.success('已取消')
            reject(error)
          })
      })
    },
    //初始化参数
    // initData(){
    //     this.isShowImg = false;
    //     this.showCardInfo = false;
    //     this.btnText = '上传';
    // },
    beforeRead(file) {
      if (
        file.type !== 'image/jpeg' &&
        file.type !== 'image/png' &&
        file.type !== 'application/x-jpg' &&
        file.type !== 'image/bmp'
      ) {
        Toast('请上传 jpg,png,jpeg,bmp 格式图片')
        return false
      }
      //重新上传身份证重新认证
      // this.initData();
      // 改变数据之后就不取原来的值
      if (this.isUploadCard) {
        this.isUploadCard = false
        this.initCardInfo()
      }
      if (this.isHaveCardImg) {
        this.isHaveCardImg = false
      }
      this.frontPicLoading = true
      return true
    },
    ...mapMutations([
      'SET_ISUPLOADIMG',
      'SET_FRONTIMG',
      'SET_BACKIMG',
      'SET_IDCARD',
      'SET_USER_INFO',
    ]),
  },
}
</script>
<style lang="less">
.infoMark {
  .van-dialog__content {
    .baseInfo {
      white-space: normal;
      line-height: normal;
      padding: 0 12px;
      li {
        line-height: normal;
        width: 100%;
        text-align: left;
        font-size: 15px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 22px 0;
        .labelText {
          display: inline-block;
          padding-right: 6px;
          width: 62px;
          font-size: 14px;
          height: 22px;
          line-height: 22px;
          font-weight: normal;
          text-align: justify;
          white-space: normal;
          overflow: hidden;
          text-align-last: justify;
          span {
            width: 100%;
            height: 0;
            display: inline-block;
          }
        }
        .colon {
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.goBackBtn {
  margin-bottom: 12px;
}

.pictureUploadBox {
  .pictureUploadContent {
    border-radius: 6px;
    background: #fff;
    margin: 12px 12px 24px;
    text-align: center;
    padding: 24px 12px;
    .CardImgContent {
      padding-top: 12px;
    }
    .pictureUploadVanCell {
      padding: 0;
      &:active {
        background-color: #fff;
      }
      &::after {
        border-bottom: none;
      }
    }
    .pictureUploadTitle {
      text-align: left;
      font-size: 15px;
    }
    .upImg {
      width: 250px;
      height: 150px;
      background: #ebecf4;
      border-radius: 2px;
      margin: 0 auto 18px;
      /deep/.van-image {
        display: block;
        width: 220px;
        height: 121px;
      }
      /deep/.van-uploader__preview {
        display: block;
        width: 220px;
        height: 121px;
        padding: 14.5px 15px;
      }
      /deep/.van-uploader__preview-delete {
        top: 14.5px;
        right: 15px;
      }
      .upBg {
        display: block;
        width: 220px;
        height: 121px;
        padding: 14.5px 15px;
      }
    }
  }
  .userCardInfo {
    .header-title {
      text-align: left;
      font-size: 15px;
      .van-cell {
        padding: 0;
        .van-cell__title {
          font-size: 15px;
        }
      }
    }
  }
  .img {
    margin-top: -10px;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .addbottom {
    margin-top: 34px;
    display: flex;
    justify-content: center;
    button {
      display: block;
      width: 160px;
    }
    button:first-child {
      margin-right: 22px;
    }
    button:last-child {
      background: #233bb7;
      border: 1px solid #233bb7;
    }
  }
  .base-info {
    margin: 8px 12px;
    padding: 10px 14px;
    .note {
      font-size: 13px;
      color: #999;
      margin-bottom: 12px;
    }
  }
}
.codeDialog {
  color: #333;
  [class*='van-hairline']:after {
    border: none;
  }
  .van-dialog__header {
    font-size: 15px;
    font-weight: bold;
  }
  .content {
    padding: 6px 24px;
    line-height: 24px;
    font-size: 14px;
    .grey-label {
      color: #999;
    }
    .top-content {
      p {
        &:last-of-type {
          text-indent: 2em;
        }
      }
    }
    .bow-content {
      border: 1px dashed #999;
      text-align: center;
      padding: 16px 0;
      margin-top: 6px;
      p {
        &:first-of-type {
          margin-bottom: 14px;
        }
      }
    }
  }
  .van-button__content {
    width: 108px;
    text-align: center;
    border: 1px solid rgb(51, 51, 51);
    height: 36px;
    border-radius: 6px;
    margin-right: 6px;
  }
  .van-button {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 12px 0 8px;
    font-size: 15px;
    &.van-dialog__confirm {
      justify-content: flex-start;
      .van-button__content {
        margin-right: 0;
        margin-left: 6px;
        background: #6c7ef3;
        color: #fff;
        border-color: #6c7ef3;
      }
    }
  }
}
</style>
<style lang="less"></style>
